"use client"

import VideoPlayerCustom from './VideoPlayerCustom'

export default function VideoPlayer(props){
    return VideoPlayerCustom(props);
}